import React from 'react';
import Card from '../Card/Card';
import { Form } from 'antd';
import ContactorTypeSelect from '../ContactorTypeSelect/ContactorTypeSelect';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { docTypes, sourceTypes } from '../../constants/documents.constants';
import { resolveContractorType } from '../../utils/getMappedFormValues';

const ContactorTypeContainer = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;

  const docType = getFieldValue('typeId');

  const { mode, formValues, draftValues } = useSelector(documentDrawerSelector);

  const showDocTypeIncludes = [docTypes.outgoing, docTypes.incoming].includes(
    docType
  );

  const isEdit = mode === 'edit';

  const hasChange =
    formValues?.canChange && formValues?.sourceId === sourceTypes.mail;

  const isDisabled = isEdit && !hasChange;

  if (!showDocTypeIncludes) return null;

  return (
    <Card
      heading="Заполните информацию о документе"
      description="От выбранного типа зависят другие характеристики"
    >
      <Form.Item style={{ margin: 0 }}>
        {getFieldDecorator('contractorType', {
          initialValue: resolveContractorType(isEdit, formValues, draftValues),
        })(<ContactorTypeSelect disabled={isDisabled} />)}
      </Form.Item>
      {isEdit &&
        formValues?.sourceId === sourceTypes.mail &&
        formValues.canChange && (
          <div style={{ color: '#0995ED', fontSize: 14 }}>
            Обратите внимание: после сохранения документа изменить данное поле
            будет невозможно
          </div>
        )}
    </Card>
  );
};

export default ContactorTypeContainer;
